import { formatNumberWithSeparators } from '../../../../../utils/number'
import { formatImportRunDate } from '../IntegrationsImportLog.utils'

export function getReprocessDescription({ locale, run, t, timezone }) {
  return t('RentalPortal.IntegrationsRunReprocessTextKey', {
    count: formatNumberWithSeparators(run.records_received),
    finished: formatImportRunDate({
      date: run.finished_at,
      locale,
      timezone,
    }),
    started: formatImportRunDate({ date: run.started_at, locale, timezone }),
  })
}
